module.exports = __webpack_public_path__ + "img/10.e38567d1.jpg";